<template>
    <v-popover offset="8" placement='bottom-start'>
        <div class="revenue-holder">
            <a :href="route">
                <h4>
                    <small style="white-space: nowrap;">{{revenueText}}:</small>
                    <span>{{formattedRevenue}}</span>
                </h4>
            </a>
            <t-loader :locked="loading" type="small"></t-loader>
        </div>
        <template slot="popover">
            <small>{{ 'revenue.paymentStatusThisMonth' | lang({'monthName': monthName}) }}</small>
            <div style="width: 460px">
                <status-progress-bar
                        class="mb-4"
                        v-if="!loading"
                        :current="status"
                        :states="states"
                        :processing="processing"
                        :onlyTooltip="false">
                </status-progress-bar>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import axios from 'axios';

  export default {

    name: "RevenueStatus",
    props: {
      route: String,
    },
    data() {
      return {
        revenue: 0,
        status: 'default',
        states: ['first'],
        processing: false,
        monthName: 'this month',
        loading: true,
        msg: '',
      }
    },
    computed: {
      revenueText() {
        //set the text depending on status
        // ['waiting', 'sending', 'sent'];
        return __('revenue.status.' + this.status);
      },

      formattedRevenue() {
        if (this.status === 'waiting' || this.status === 'loading') {
          return "$---";
        }

        return "$" + parseFloat(this.revenue).toFixed(2);
      },
    },
    methods: {
      load() {
        axios.get('/revenues/monthlyRevenue').then(response => {
          this.revenue = response.data.revenue;
          this.status = response.data.status;
          this.states = response.data.states;
          this.processing = response.data.processing;
          this.monthName = response.data.monthName;

        }).catch(error => {
          this.toast.error(error.message);
        }).finally(() => {
          this.loading = false;
        });
      },
    },
    mounted() {
      this.msg = __('revenue.tooltip');
      this.load();
    }
  }
</script>

<style>
    .revenue-holder {
        /*position: relative;*/
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
    }

    .tooltip-inner {
        max-width: unset;
    }

    .v-tooltip.v-popover .popover-inner {
        padding: 0.5rem !important;
    }

    .progress-wrap {
        margin: 25px auto !important;
        padding-bottom: 20px;
    }
</style>